import dayjs from "dayjs";
import { IFixPersonToManager } from "../../../interfaces/store/slices/listAgentSlice";

export const getAttachManagerFixDate = (value: string) => {
  return `Добавлен: ${dayjs(value).format("DD.MM.YYYY")}`;
};
